// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AlterarBloqueioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /agenda/alterar_bloqueio
 *
 * Returns success flag indicating whether the bloqueio was updated.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Agenda_AlterarBloqueioResponseDados = boolean;

export type Agenda_AlterarBloqueioResponse = ApiResponse<Agenda_AlterarBloqueioResponseDados>;

registerResponseContract('Agenda_AlterarBloqueioResponse', {})
